import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import {isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));
const Options2=[
    {value:"",Meta:<IntlMessages id="Choose"/>},
    {value:"0",Meta:<>0<IntlMessages id="Days"/></>},
    {value:"10",Meta:<>10 <IntlMessages id="Days"/></>},
    {value:"15",Meta:<>15 <IntlMessages id="Days"/></>},
    {value:"20",Meta:<>20 <IntlMessages id="Days"/></>},
    {value:"30",Meta:<>30 <IntlMessages id="Days"/></>},
    {value:"AG",Meta:<IntlMessages id="Direct.debit"/>},
    {value:"K",Meta:<IntlMessages id="Cash"/>},
    {value:"PF",Meta:<IntlMessages id="Cash.On.delivery"/>},
]
function Text(props) {
    const classes = useStyles();
    const [Value,setValue] = React.useState(props.Value)
    const handleChange=(e)=>{
        //console.log(date)
        setValue(e.target.value)
        props.onchangeHanelEvent(props.Meta,e.target.value)
    }
    
    return (
        <div>
             <TextField
                    label={props.Label}
                    select
                    fullWidth
                    size="small"
                    value={props.disAbeld === true?"Månader":Value}
                    disabled={props.disAbeld}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    variant="outlined"
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                >
                    {
                 Options2.map(item=>{
                return <option value={item.value}>{item.Meta}</option>
                })}
                </TextField>
        </div>
    );
}

export default Text;